import axios from "axios";
import React from 'react';
import Swal from "sweetalert2";
import {Cookies} from "react-cookie";
import {enableBanjercito} from "../index";

export function handleSubmitLogin(username, password, executive, isPublic) {

    //credentials to: x-www-form-urlencoded
    const credentials = new URLSearchParams();
    credentials.append('username', username);
    credentials.append('password', password);

    let endpointLogin;

    if (executive === "2") {
        endpointLogin = '/v1/reactor/security/api_login';
    } else if (executive === "1") {
        endpointLogin = '/v1/reactor/security/krn_login';
    }

    Swal.fire({
        title: 'Cargando...',
        showConfirmButton: false,
        allowOutsideClick: false,
        didOpen: () => {
            Swal.showLoading()
            return axios.post(process.env.REACT_APP_IP + endpointLogin, credentials)
                .then(response => {
                    if (response.data.JWT && isPublic) {
                        localStorage.setItem("isAuthenticated", JSON.stringify(response.data));
                    } else {
                        //localStorage.removeItem("isAuthenticated");
                    }
                    //Assignment of roles to future petitions
                    const auditId = response.data.userId;
                    const rolId = response.data.userTypeId;
                    const krnCustomerId = response.data.krnCustomerId;
                    const poolCustomerId = response.data.poolCustomerId;

                    const cookies = new Cookies();
                    cookies.set('auditId', auditId, {path: '/'});
                    cookies.set("rolId", rolId, {path: '/'});
                    cookies.set("externalUser", !executive, {path: '/'});
                    cookies.set("krnCustomerId", krnCustomerId, {path: '/'});
                    cookies.set('poolCustomerId', poolCustomerId, {path: '/'});            
                    
                    //If we log in we delete token for public users
                    //localStorage.removeItem('genericAuth');

                    if (!isPublic) return window.location = '/#/cotizadorAdministrador';
                })
                .then(() => Swal.close()).catch(() => {
                    let message;
                    {
                        executive == false ?
                            message = 'Favor de ingresar usuario y contraseña nuevamente. En caso de ser ejecutivo marcar la casilla e intentar de nuevo.'
                            : message = 'Favor de ingresar usuario y contraseña nuevamente.'
                    }
                    Swal.fire({
                        title: 'Credenciales incorrectas',
                        text: message,
                        icon: 'error',
                        iconColor: 'var(--skrSecondary)',
                        backdrop: `rgba(71, 10, 104, .75)`,
                        showCancelButton: true,
                        showConfirmButton: false,
                        cancelButtonColor: 'var(--skrSecondary)',
                        cancelButtonText: 'Volver a intentar'
                    });
                });
        }
    })
}

export async function getTokenGeneric() {
    const response = await axios.get(process.env.REACT_APP_IP + '/v1/reactor/security/tokengeneric');
    if (response.data.JWT) {
        localStorage.setItem("genericAuth", JSON.stringify(response.data));
    }
    return response.data;
}

export function bearerTokenHeader() {
    const auth = JSON.parse(localStorage.getItem('isAuthenticated'));
    const genericAuth = JSON.parse(localStorage.getItem('genericAuth'));
    if (auth && auth.JWT) {
        return {Authorization: 'Bearer ' + auth.JWT};
    } else if (genericAuth && genericAuth.JWT) {
        return {Authorization: 'Bearer ' + genericAuth.JWT};
    } else {
        return {}
    }
}

export function kernoCustomerIdHeader() {
    const cookies = new Cookies();
    let krnCustId = cookies.get('krnCustomerId');
    if (krnCustId) {
        return {krnCustomerId: krnCustId};
    } else {
        return {krnCustomerId: ''};
    }
}

export function externalUserHeader() {
    const cookies = new Cookies();
    let externalUser = cookies.get('externalUser');
    return {externalUser: externalUser || ''};
}

export function auditIdHeader() {
    const cookies = new Cookies();
    let auditIdHeader = cookies.get('auditId');
    if (auditIdHeader) return {AuditId: auditIdHeader};
    else return {AuditId: ''};
}

export function poolCustomerIdHeader() {
    const cookies = new Cookies();
    let poolCustomerId = cookies.get('poolCustomerId');
    if (poolCustomerId) return {PoolCustomerId: poolCustomerId};
    else return {PoolCustomerId: ''};
}

export function basicAuthHeader() {
    return {
        username: 'roberto.escalante',
        password: 'SKR/rev.1'
    };
}

export function handleLogout() {
    localStorage.removeItem('isAuthenticated');    
    const cookies = new Cookies();
    cookies.remove("auditId");
    cookies.remove("rolId");
    cookies.remove("externalUser");
    cookies.remove("krnCustomerId");
    cookies.remove("poolCustomerId");
    //if (enableBanjercito)
        return window.open('/#/cotizador', '_self');
    //else
        //return window.open('/#/cotizador', '_self');
}

export async function getUserPermission(userId) {
    const response = await axios.get(process.env.REACT_APP_IP + '/users/getpermission/' + userId, {
        auth: {
            username: 'roberto.escalante',
            password: 'SKR/rev.1'
        }
    });
    return response.data;
}

export async function getUserConfiguration(poolCustomerId) {
    const response = await axios.get(process.env.REACT_APP_IP + '/insurancehub/extraction/customers/' + poolCustomerId);
    return response.data;
}